module.exports = __webpack_public_path__ + "static/img/beijing.fd7d4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beijing.png
// module id = TP5V
// module chunks = 1